import AxiosClient from '../../../services/axios.services';

class SurveyResultsServices {
  getSurveyResults = (params) =>
    AxiosClient.get(`/api/app/SurveyResult/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getSurveyInfo = (surveyId) =>
    AxiosClient.get(`/api/app/Survey/${surveyId}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new SurveyResultsServices();